// Importing necessary modules and dependencies
import * as THREE from 'three';
import EventDispatcher from "../common/EventDispatcher";
import {
    Global
} from "../common/global";
import {
    gsap,
    Cubic
} from 'gsap';
import { isMobile } from 'mobile-device-detect';

// Constants for car physics and behavior
const CAR_SPEED_Z_REDUCER = 2;


const RAYCAST_INTERVAL=3;
const CAR_SCALE= 25*.01;//0.4;
const CAR_SPEED_Z_EXP = 4;
const CAR_BRAKE_FACTOR = 2;
const CAR_RESTING_LERP_FACT = 0.001;
const WHEEL_ROTATION_FACT = 1.5*2;
const WHEEL_TURN_FACT = 300;
const WHEEL_TURN_LERP = 0.075 ;
const GRAVITY = .00981 * .5;
// const CAR_DEFAULT_POS = new THREE.Vector3(
//   -12.334014745190794+.7,
//     -11.853007979951686,
//   -1231.1750183342988
// );
const CAR_DEFAULT_POS=new THREE.Vector3(.1,0-1,-8)
const BASE_SPEED=0.2;
// const CAR_DEFAULT_POS = new THREE.Vector3(-215.6439513524535, 446.24389927947715, 539.8424239908959);
// const CAR_DEFAULT_POS = new THREE.Vector3(-215, 450.24389927947715, 500);
const COLLISTION_SPEED_REDUCE_FACT= 0.15;
const WALL_COLLISTION_SPEED_REDUCE_FACT= 0.5;

// PlayerCar class definition
export default class PlayerCar {
    constructor(scene) {
        this.scene = scene;



        this.maxSpeed={
            "Car":.56,
            "Truck":.5,
            "Bike":.52
        }
        this.accelaration={
            "Car":1,
            "Truck":0.9,
            "Bike":1.5
        }
        this.handling={
            "Car":0.75,
            "Truck":1,
            "Bike":0.6
        }
        this.braking={
            "Car":1.25,
            "Truck":1.1,
            "Bike":1.2
        }
        this.resetInProgress=false;
        this.boosterTO=null;
        Global.boostActivated=false;
        Global.invinsibleActivated=false;
        this.invinsibleObj={
            value:1
        }
        
        this.AICarTriggered=false;
        this.wrongwayTO=null;
        this.wrongWayIndicatorIsOn=false;
        this.wrongWayBlocked=false;
        this.wrongWayResetDone=false;
        this.invinsibleMaterials=[];
        this.interacted=false;
        this.currentAnim=null;
        this.vehicleKey=null
        this.baseSpeedCrossed=false;
        this.raycastCooldown=0;
        this.lastForceY=0;
        this.carSpeedGyroReducer = 1;
        this.rotateWheel = true;
        this.initZ = /* -Math.PI/7 */-Math.PI * .0125;
        this.carRotateZ = 0;
        this.speed = 0;
        this.firstChecked = false;
        this.stableY = 0;
        this.accDueToGravity = 0;
        this.lastDistance = 0;
        this.currDistance = 0;
        this.speedAqcuired = 0;
        this.wheelBack = null;
        this.frontWheel1 = null;
        this.frontWheel2 = null;

        this.lightMaterial = null;
        this.rotateAngle = 0;
        this.brakeApplied = false;
        this.lightIntensity = {
            'value': 0
        }

        this.nowTotal = 0;
        this.lastTotal = 0;
        this.distanceCovered = 0;
        this.indicatorActive = false;

        this.onEvents=this.onEvents.bind(this)
    }

    // Initialization method
    init(carKey) {
        this.carKey = carKey;


        this.missAlignedCnt=0;
        this.lastPosition= CAR_DEFAULT_POS;
        Global.collectables=[];
        Global.cars=[];
        Global.boostActivated=false;
        Global.invinsibleActivated=false;
        Global.levelCompleted= false;
        Global.gameFailed=false;
        Global.gameOver=false;

        this.boosterCnt=0;
        this.invinsibleCnt=0;

        Global.carPositionIndex[this.carKey] = 1;
        this.events = EventDispatcher.getObj();
        this.events.addEventListener("PLAYER_EVENTS", this.onEvents);
        this.events.addEventListener("GAMESCENE_EVENTS", this.onEvents);
        this.events.addEventListener("GAMECONTROL_EVENTS", this.onEvents);
        this.events.addEventListener("GAME_EVENTS", this.onEvents);

        this.carModel = null;

        // Creating raycasters for collision detection
        this.raycaster1 = new THREE.Raycaster();
        this.raycaster2 = new THREE.Raycaster();
        this.raycaster3 = new THREE.Raycaster();
        this.lastValidPosition=new THREE.Vector3()
        this.lastValidRotation=new THREE.Vector3()

        this.raycaster1.firstHitOnly = true;
        this.raycaster2.firstHitOnly = true;
        this.raycaster3.firstHitOnly = true;

        this.raycaster1.far = 5;
        this.raycaster2.far = 5;
        this.raycaster3.far = 5;

        this.points = [];

      
        this.mask = document.querySelector('.speed_icon');

    
    }

    // Event handler for various events
    onEvents(data) {
        switch (data['message']['event_type']) {
            case "reset_game":
                this.reset();
                break;
            case "add_car":
                this.addCar(data['message']['data']);
                break;
            case "update_player_car":
                this.updateCar(data['message']['data']);
                break;
            case "update":
                this.update(data['message']['data']);
                break;
            case "steer":
                this.steerCar(data['message']['data']);
                break;
            case "align_car_to_elevation":
                this.placeCarOnRoad(data['message']['data']);
                break;
            case "start_game":
                this.firstChecked= false;
                this.gameStarted = true;
                setTimeout(() => {
                    this.interacted=false;
                    this.firstChecked= true;
                },500)
                break;
            case "update_gyro_factor":
                this.updateGyroFactor(data['message']['data']);
                break;
            case "collectables_aquired":
                this.onCollected(data['message']['data'])
                break;
            case "dispose":
                this.dispose();
                break;
    }
}
   
    // gainBaseSpeed(){

    // }
    // lose
    onCollected(data){
        switch(data['collect_type']['collectableType']){
            case 'caramel':
                this.activateTimeDiscount(data['collect_type']['collectableType']);
                break;
            case 'mocha':
                this.activateInvincible();
                break;
            case 'oat275':
            case 'original275':
                this.activateBooster();
                break;
                
        }
    }
    activateBooster(){
        // console.log("COLLECTABLE NOTIFICATION::: BOOSTER ACTIVATED")
        this.hideAllInfo();
        document.querySelector(".game_info .info_booster").classList.add("active")
        Global.boostActivated= true;

        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'speedBoost'
                }
            }
        });
        this.boosterCnt+=8;
        
        this.boosterTO && clearInterval(this.boosterTO);
        this.boosterTO= setInterval(this.updateBooster.bind(this), 1000)

        this.boosterTO2 && clearTimeout(this.boosterTO2);
        this.boosterTO2= setTimeout(this.hideAllInfo.bind(this), 1000)
    }
    updateBooster(){
        this.boosterCnt--;
        if(this.boosterCnt<=0){
            this.boosterTO && clearInterval(this.boosterTO);
            Global.boostActivated= false;
        }
        // console.log("COLLECTABLE NOTIFICATION::: BOOSTER DEACTIVATED")
     
    }
  
    hideAllInfo(){
        document.querySelector(`.game_info .info_invinsible`).classList.remove("active")
        document.querySelector(`.game_info .info_booster`).classList.remove("active")
        document.querySelector(`.game_info .info_timebonus`).classList.remove("active")
    }
    activateInvincible(){
        // console.log("COLLECTABLE NOTIFICATION::: INVINSIBLE ACTIVATED")
        this.hideAllInfo();
        document.querySelector(".game_info .info_invinsible").classList.add("active")
        Global.invinsibleActivated= true;

        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'invinsible'
                }
            }
        });

        gsap.killTweensOf(this.invinsibleObj);
        this.invinsibleObj.value=1;

        this.invincibleTO && clearTimeout(this.invincibleTO);
        this.invincibleTO= setTimeout(this.hideAllInfo.bind(this), 1000)

        gsap.to(this.invinsibleObj, {
            value:0.15,
            repeat: 25,
            yoyo: true,
            duration:0.35,
            onUpdate: function(){
                this.invinsibleMaterials.forEach((material)=>{
                    material.opacity=this.invinsibleObj.value;
                })
            }.bind(this),
            onComplete: this.deActivateInvincible.bind(this)
        })

    }
    deActivateInvincible(){
        // console.log("COLLECTABLE NOTIFICATION::: INVINSIBLE DEACTIVATED")
        Global.invinsibleActivated= false;
        gsap.killTweensOf(this.invinsibleObj);
        this.invinsibleObj.value=1;
    }
    activateTimeDiscount(collectType){
        this.hideAllInfo();
        // console.log("COLLECTABLE NOTIFICATION::: DISCOUNT ACTIVATED")
        document.querySelector(".game_info .info_timebonus").classList.add("active")

        this.events.dispatchEvent({
            type: "GAME_EVENTS",
            message: {
                    "event_type": "time_deduct",
                    "data": {
                        "collect_type":collectType
                    }
                }
        });

        this.events.dispatchEvent({
            type: "SOUND_EVENTS",
            message: {
                "event_type": "play_sound",
                data: {
                    'sndKey': 'timeDeduct'
                }
            }
        });


        this.discountTO && clearTimeout(this.discountTO);
        this.discountTO= setTimeout(this.hideAllInfo.bind(this), 1000)
    }
    showOrHiTailLight(value) {
        // this.lightIntensity['value'] = .05;
        this.lightTwn && this.lightTwn.kill();

        this.lightTwn = gsap.to(this.lightIntensity, {
            duration: value == 0 ? 0.17 : 0.5,
            value: value,
            repeat: 0,
            yoyo: false,
            ease: value == 0 ? Cubic.easeOut : Cubic.easeIn,
            onUpdate: function () {
                this.lightMaterial && (this.lightMaterial.emissiveIntensity = this.lightIntensity['value']);
            }.bind(this)
        })
    }
    //this.lightMaterial

    // Method to control steering of the car
    steerCar(data) {
        if (!this.gameStarted || this.resetInProgress) return false;

       
        this.rotateAngle = data['forceX'];
        this.rotateWheel = data['rotate_wheel'];
        if(data['forceY']<0) this.interacted=true;
        // this.carRotateZ += Math.PI * data['forceX'] * (2 - Math.pow(this.speed * CAR_SPEED_Z_REDUCER * this.carSpeedGyroReducer, CAR_SPEED_Z_EXP*1)) * ((this.speed).toFixed(2) != 0 ? 1 : 0) * Global.delta;//(Global.isGyro?0.6:1)
        if(Math.abs(this.speed)>0){
            this.carRotateZ += this.handling[this.vehicleKey]*0.5*Math.PI * data['forceX'] * (1 - Math.min(0.45/* 0.7 */,Math.pow(this.speed * CAR_SPEED_Z_REDUCER * this.carSpeedGyroReducer, CAR_SPEED_Z_EXP*1))) * ((this.speed).toFixed(2) != 0 ? 1 : 0) * Global.delta;//(Global.isGyro?0.6:1)
        }
       if(this.vehicleKey=="Bike"){
       
        if(!data['directionApplied']){
            // this.straightAnim.enabled = true;
            this.straightAnim.setEffectiveWeight(10);
            this.straightAnim.crossFadeTo(this.leftAnim, 0.3, false);
            this.straightAnim.crossFadeTo(this.rightAnim, 0.3, false);
            if(this.currentAnim!=="straight"){
                this.currentAnim="straight"
                gsap.killTweensOf(this.carModel)
                gsap.to(this.carModel.rotation, {
                   z:0,
                   duration:0.2,
                  
               })
                
            }
            
            this.straightAnim.play();
        }else{
            if(data['forceX']<0){
                if( this.currentAnim!="right"){
                     this.currentAnim="right"
                     gsap.killTweensOf(this.carModel)
                     gsap.to(this.carModel.rotation, {
                        z:-0.15,
                        duration:0.2,
                       
                    })
                }
             
                // this.rightAnim.enabled = true;
            this.rightAnim.setEffectiveWeight(1);
            this.rightAnim.crossFadeTo(this.leftAnim, 0.3, false);
            this.rightAnim.crossFadeTo(this.straightAnim, 0.3, false);
            this.rightAnim.play();
            }else{
                if( this.currentAnim!="left"){
                    this.currentAnim="left"
                    gsap.killTweensOf(this.carModel)
                    gsap.to(this.carModel.rotation, {
                       z:0.15,
                       duration:0.2,
                      
                   })
               }
                // this.leftAnim.enabled = true;
                this.leftAnim.setEffectiveWeight(1);
                this.leftAnim.crossFadeTo(this.rightAnim, 0.3, false);
                this.leftAnim.crossFadeTo(this.straightAnim, 0.3, false);
                this.leftAnim.play();
            }
        }
       
       }
        
         
   
        if (data['forceY'] > 0) {
            if (!this.brakeApplied) {
              
                this.brakeApplied = true;
                this.showOrHiTailLight(10000);
            }
            if (this.speed >= 0) {
                this.baseSpeedCrossed= false;
                this.speed += data['forceY'] * -CAR_BRAKE_FACTOR * this.braking[this.vehicleKey];
                this.speed= Math.max(0, this.speed);
            }
        } else {
            if(!this.resetInProgress){
                if (this.brakeApplied) {
                    // this.baseSpeedCrossed= false;
                    this.brakeApplied = false;
                    this.showOrHiTailLight(0);
                }
    
                if (data['forceY'] == 0) {
                    this.speed = new THREE.Vector3(0, Math.max(0, this.speed - this.accDueToGravity), 0).lerp(new THREE.Vector3(0, 0, 0), CAR_RESTING_LERP_FACT * Global.delta).y;
                }
                if (this.speed <= this.maxSpeed[this.vehicleKey]*(Global.boostActivated?1.5:1)) {
                    if (data['forceY'] != 0) {
                        this.speed += (data['forceY']) * -1 * this.accelaration[this.vehicleKey]*(Global.boostActivated?4:1);
                    }
                }else{
                    const decelerationFactor = .025; // Adjust this value for a smoother or quicker reduction
                    this.speed = this.speed - (this.speed - this.maxSpeed[this.vehicleKey]) * decelerationFactor;
                }
            }
           

        }
        if(!this.interacted){
            this.speed=0;
        }
        if(this.lastForceY == 0 && data['forceY']<0 && this.speed > 0 && this.interacted){
       
            this.lastForceY= data['forceY'];
        }
        if((data['forceY'] == 0 && this.lastForceY!=0) ){
          
        }
        if(data['forceY'] ==0 ){
            this.lastForceY=data['forceY'];
        }
        if(this.speed!=0 && !this.AICarTriggered){
            this.AICarTriggered= true;
            this.events.dispatchEvent({
                type: "PLAYER_EVENTS",
                message: {
                    "event_type": "start_AI",
                    "data": {
                    }
                }
            });
        }
        
       
    }
    updateGyroFactor(data) {
        this.carSpeedGyroReducer = data['factor'];
    }
    // Update method for car movement and physics
    update(data) {
        if(Global.gamePaused) {return false;}

        if (this.turnMixer) {
            this.turnMixer.update(.05);
        }
        if(Global.levelCompleted || Global.gameFailed){
           
            if (this.speed >= 0) {
                this.speed += .0007*-CAR_BRAKE_FACTOR;
                this.speed= Math.max(0, this.speed)
            }
        }
        
        if (this.carModel != null) {
           
            // console.log(this.carModel.position,'pos')
            // return false;
            if (this.gameStarted) {
                this.nowTotal = data['now'] || 0;

                this.nowTotal -= this.lastTotal;
                if (this.nowTotal >= 1000) {
                    this.lastTotal += this.nowTotal;
                    this.nowTotal = 0;
                    // this.processPosition();
                }
                if (this.speed < BASE_SPEED && (!Global.levelCompleted && !Global.gameFailed && !this.resetInProgress) && this.interacted) {
                    this.speed = THREE.MathUtils.lerp(this.speed, BASE_SPEED * (this.brakeApplied?1:1), this.baseSpeedCrossed?0.75:0.005);
                    this.brakeApplied && (this.speed= Math.max(BASE_SPEED*.25,this.speed))
                }else if(this.interacted){
                    this.baseSpeedCrossed=true;
                }

            }
            // if(!this.interacted){
            //     this.speed=0;
            // }
            this.carModel.rotation.y = this.initZ + this.carRotateZ+(this.frontWheel1.rotation.y)*0.2*this.speed;
            this.lastDistance = this.carModel.position.clone();

            this.carModel.translateOnAxis(new THREE.Vector3(0, 0, -1 * Global.delta), this.speed*(Global.boostActivated?1:1.08));
            //distanceCovered

            /* 
            
                   this.wrongWayIndicatorIsOn=false;
        this.wrongWayResetDone=false;
            */
            const positioDiff= this.carModel.position.clone().sub(this.lastPosition);
           
            if(positioDiff.z>0&& !this.wrongWayBlocked){
                this.placeWrongwayBlocker();
            }
            // console.log(positioDiff,'positioDiff')
            if(positioDiff.z<=0 && this.wrongWayBlocked){
                this.wrongWayBlocked=false;
            }
           if(positioDiff.z>20 && !this.wrongWayIndicatorIsOn && this.gameStarted){
                this.showWrongwayIndicator();
                // alert("Show Wrong Wsay DIFF")
            }
            if(this.wrongWayIndicatorIsOn){
                this.lastPosition=this.carModel.position.clone();
            }
            if(positioDiff.z<=0 && this.gameStarted){
                this.lastPosition=this.carModel.position.clone();
                if(this.wrongWayIndicatorIsOn){
                    this.hideWrongwayIndicator();
                }
            }
            // console.log(positioDiff.z,'DIFF')
            // if(this.lastPosition.sub())

            
            // this.carModel.translateOnAxis(new THREE.Vector3(-1 * Global.delta*0, 0, -this.carModel.getWorldDirection(new THREE.Vector3(1,1,1)).z), this.speed);
            this.currDistance = this.carModel.position.clone();
            this.speedAqcuired = Math.floor(Math.pow(this.currDistance.distanceTo(this.lastDistance) * 125 / Global.delta / 5, 2) * 0.8);
        }

        if (this.carModel) {

            this.carBox.position.set(...this.carModel.position);
            this.carBox.rotation.set(...this.carModel.rotation);

            this.carBox2.position.set(...this.carModel.position);
            this.carBox2.rotation.set(...this.carModel.rotation);
            this.carBox2.rotation.x=0
            
            this.events.dispatchEvent({
                type: "PLAYER_EVENTS",
                message: {
                    "event_type": "move_player",
                    "data": {
                        "position": this.carModel.position.clone(),
                        "rotation": this.carModel.rotation.clone(),
                        "entity": this.carModel,
                        "speed": this.speed,
                        "wheelRotateY": this.frontWheel1.rotation.y
                    }
                }
            });
        }

        if (this.carModel && this.rotateWheel) {
            this.frontWheel1.rotation.x -= this.speed * WHEEL_ROTATION_FACT * Global.delta;
            this.frontWheel2 && (this.frontWheel2.rotation.x -= this.speed * WHEEL_ROTATION_FACT * Global.delta);
            this.wheelBack.rotation.x -= this.speed * WHEEL_ROTATION_FACT * Global.delta;

            this.frontWheel1.rotation.y = THREE.MathUtils.lerp(this.frontWheel1.rotation.y, (this.rotateAngle*0.75) * WHEEL_TURN_FACT*0.1, WHEEL_TURN_LERP * Global.delta);
            this.frontWheel2 && (this.frontWheel2.rotation.y = THREE.MathUtils.lerp(this.frontWheel2.rotation.y, (this.rotateAngle*0.75) * WHEEL_TURN_FACT*0.1, WHEEL_TURN_LERP * Global.delta));
        }

        if( document.querySelector(".speed_ui .value")){
            const percentage = (this.speedAqcuired / this.maxSpeedIndicator)*68; // Convert speed to angle (0-180 deg)
            this.mask && this.mask.style.setProperty('--progress', `${percentage}%`);

            document.querySelector(".speed_ui .value").innerHTML = `${this.speedAqcuired}`;

        }
    }
    placeWrongwayBlocker(){
        this.wrongWayBlocked=true;
        this.events.dispatchEvent({
            type: "PLAYER_EVENTS",
            message: {
                "event_type": "place_blocker",
                data: {
                    "position": this.carModel.position
                }
            }
        });
    }
    hideWrongwayIndicator(){
        this.wrongWayIndicatorIsOn= false;
        document.querySelector(".wrong_way_indicator").classList.remove("active");
        this.wrongwayTO && clearTimeout(this.wrongwayTO);
    }
    showWrongwayIndicator(){
        this.wrongWayIndicatorIsOn= true;
        document.querySelector(".wrong_way_indicator").classList.add("active")
        this.wrongwayTO= setTimeout(()=>{
            this.disableVehicle();
        }, 5000)
    }
    disableVehicle(){
        Global.gameFailed=true;
        this.events.dispatchEvent({
            type: "GAMESCENE_EVENTS",
            message: {
                "event_type": "disable_control",
                data: {
                }
            }
        });
        this.baseSpeedCrossed=false;
    }
    // Method to place the car on the road considering elevation

    alignVehicleOnRoad(intersects){
        this.missAlignedCnt=0;
        this.stableY = intersects[0].point.y+ 0.05;
        this.carModel.position.y = this.stableY;

        this.lookAtTarget = intersects[0].point.clone().add(intersects[0].face.normal);
        this.shadowPlane.position.set(this.carModel.position.x, this.carModel.position.y -2, this.carModel.position.z);
        this.events.dispatchEvent({
            type: "GAMESCENE_EVENTS",
            message: {
                "event_type": "car_position",
                "data": {
                    "target": this.carModel
                }
            }
        });
        const normalMatrix = new THREE.Matrix3().getNormalMatrix(intersects[0].object.matrixWorld);
        const roadNormal = intersects[0].face.normal.clone().applyMatrix3(normalMatrix).normalize();
        const targetRotation = new THREE.Euler().setFromRotationMatrix(
            new THREE.Matrix4().lookAt(new THREE.Vector3(), roadNormal, this.carModel.up)
        );
        const worldQuaternion = this.carModel.quaternion.clone();
        const euler = new THREE.Euler().setFromQuaternion(worldQuaternion, this.carModel.rotation.order);
        const accDueToGravity = -Math.sin(euler.x) * GRAVITY;
        let adjustedAccDueToGravity = accDueToGravity;
        if (adjustedAccDueToGravity > 0) {
            adjustedAccDueToGravity *= 0.5;
        }
        this.accDueToGravity = adjustedAccDueToGravity;
        if(Global.gameOver){
            this.accDueToGravity=0;
        }
        this.accDueToGravity=0;
        this.carModel.rotation.x += (targetRotation.x +(Global.gameLevel==1?-1:1) * Math.PI / 2 - this.carModel.rotation.x) * (!this.firstChecked ? 1 : Math.max(this.speed, .1) * .25) * Math.min(1, Global.delta);
        this.shadowPlane.rotation.x = this.carModel.rotation.x + Math.PI / 2;
    }
    placeCarOnRoad(data) {

        if (this.carModel == null) return false;
        if(this.events == null) return false;
        this.carModel.updateMatrixWorld();
        // return false;

        // Configuring raycasters for collision detection
        // this.raycaster1.ray.origin.copy(this.carModel.position.clone());
        this.raycaster1.ray.origin.copy(this.carModel.position.clone().add(new THREE.Vector3(0,1,0)));

        this.raycaster1.ray.direction.copy(new THREE.Vector3(0, -1, 0));
        this.raycaster1.ray.direction.normalize();

      
        const length = 10;
        const endPoint = new THREE.Vector3();
        endPoint.copy(this.raycaster3.ray.origin).add(this.raycaster3.ray.direction.clone().multiplyScalar(length));

        const intersects1 = this.raycaster1.intersectObjects(data['road'], false);// Change to true       
        
        if(!Global.gameOver){
            const intersectsOnFinish = this.raycaster1.intersectObjects(data['finishLine'], false);

            if(intersectsOnFinish.length>0){
            
                this.showOrHiTailLight(1);
                Global.boostActivated=false;
                Global.levelCompleted= true;
                 this.events.dispatchEvent({
                     type: "GAMESCENE_EVENTS",
                     message: {
                         "event_type": "game_over",
                         data: {
                         }
                     }
                 });
                //  if(Global)
             }
        }
       
        if (intersects1.length > 0) {
            this.alignVehicleOnRoad(intersects1)  
        }else{
            this.raycaster1.ray.origin.copy(this.carModel.position.clone());
            this.raycaster1.ray.direction.copy(new THREE.Vector3(0, 1, 0));
            this.raycaster1.ray.direction.normalize();
            const intersects1 = this.raycaster1.intersectObjects(data['road'], false);
            if (intersects1.length > 0) {
                this.alignVehicleOnRoad(intersects1)  
            }
        }
        if (intersects1.length == 0 && this.gameStarted) {
            this.missAlignedCnt++;
            if(this.missAlignedCnt>=15){
                this.resetCarOnRoad();
            }
           
        }


        // return false;

        let wallCollided=false;
        this.raycaster2.ray.origin.copy(this.carModel.position.clone());
        this.raycaster2.ray.direction.set(1, 0, -1).applyQuaternion(this.carModel.quaternion);
        const intersects2 = this.raycaster2.intersectObjects(data['wall'], true);

       
        let otherCars = [...Global.cars];
        otherCars.splice(otherCars.indexOf(this.carBox), 1);




        this.carBox.updateMatrixWorld();

      






        
        // Handling collisions with wall objects
        if (intersects2.length > 0 && intersects2[0].distance <= (this.vehicleKey=="Bike"?0.25:1) && !wallCollided) {
            var intersectionPoint = intersects2[0].point;
            var distance = this.raycaster2.ray.origin.distanceTo(intersectionPoint);
            var intensity = 1 / (distance + 1);

            const normal = intersects2[0].face.normal.clone();
            const carDirection = new THREE.Vector3();
            this.carModel.getWorldDirection(carDirection);
            const angle = Math.abs(carDirection.angleTo(normal) - Math.PI / 4);
          
            
            // this.speed *= 1-Math.min(1, (angle>=0?angle:Math.PI+angle)*WALL_COLLISTION_SPEED_REDUCE_FACT);

            if(intersects2[0].object.name.indexOf('5_cans')==-1){
                this.carRotateZ += Math.PI / (angle<=0?75:(Global.vehicleType=="Bike"?50:100)) * (1 + angle<=0?angle:Math.PI+angle);
                // this.carRotateZ += Math.PI / (angle<=0?75:(Global.vehicleType=="Bike"?50:100)) * (1 + angle<=0?angle:Math.PI+angle);
                this.speed *= 1-Math.min(1, (angle>=0?angle:Math.PI+angle)*WALL_COLLISTION_SPEED_REDUCE_FACT);
    
            }
            else{
                this.resetCarOnRoad();
                // this.carRotateZ += (Math.PI / (angle<=0?75:(Global.vehicleType=="Bike"?50:100)) * (1 + angle<=0?angle:Math.PI+angle))*.5;
                // this.speed *=.03;//1-Math.min(1, (angle<=0?angle:Math.PI+angle)*WALL_COLLISTION_SPEED_REDUCE_FACT);//(1 - Math.min(intensity / (Global.isGyro?5:2) * Global.delta, 1));
               }
            this.events.dispatchEvent({
                type: "CAMERA_EVENTS",
                message: {
                    "event_type": "shake_camera",
                    "data": {
                        "shake_fact": .1,
                        "intensity": angle,
                        "shake_time": 0.25
                    }
                }
            });
            wallCollided= true;
            this.events.dispatchEvent({
                type: "SOUND_EVENTS",
                message: {
                    "event_type": "play_sound",
                    data: {
                        'sndKey': 'hit'
                    }
                }
            });
        }

        if(!wallCollided){
            
            this.raycaster3.ray.origin.copy(this.carModel.position.clone());
            this.raycaster3.ray.direction.set(-1, 0, -1).applyQuaternion(this.carModel.quaternion);
            const intersects3 = this.raycaster3.intersectObjects(data['wall'], true);
    
            if (intersects3.length > 0 && intersects3[0].distance <= (this.vehicleKey=="Bike"?0.25:1)) {
          
                var intersectionPoint = intersects3[0].point;
                var distance = this.raycaster3.ray.origin.distanceTo(intersectionPoint);
                var intensity = 1 / (distance + 1);
    
                const normal = intersects3[0].face.normal.clone();
                const carDirection = new THREE.Vector3();
                this.carModel.getWorldDirection(carDirection);
                const angle = carDirection.angleTo(normal)- Math.PI/4;
                
                
               if(intersects3[0].object.name.indexOf('5_cans')==-1){  
                this.carRotateZ -= Math.PI / (angle>=0?75:(Global.vehicleType=="Bike"?50:100))  * (1 + (angle>=0?angle:Math.PI+angle));
                    this.speed *= 1-Math.min(1, (angle<=0?angle:Math.PI+angle)*WALL_COLLISTION_SPEED_REDUCE_FACT);//(1 - Math.min(intensity / (Global.isGyro?5:2) * Global.delta, 1));
               }else{
                this.resetCarOnRoad();
                // this.carRotateZ -= (Math.PI / (angle>=0?75:(Global.vehicleType=="Bike"?50:100))  * (1 + (angle>=0?angle:Math.PI+angle)))*.5;
                // this.speed *=.03;//1-Math.min(1, (angle<=0?angle:Math.PI+angle)*WALL_COLLISTION_SPEED_REDUCE_FACT);//(1 - Math.min(intensity / (Global.isGyro?5:2) * Global.delta, 1));
               }
               
    
                // Dispatching camera shake event on collision
                this.events.dispatchEvent({
                    type: "CAMERA_EVENTS",
                    message: {
                        "event_type": "shake_camera",
                        "data": {
                            "shake_fact": .1,
                            "intensity": angle,//intensity / 2,
                            "shake_time": 0.25
                        }
                    }
                });
                this.events.dispatchEvent({
                    type: "SOUND_EVENTS",
                    message: {
                        "event_type": "play_sound",
                        data: {
                            'sndKey': 'hit'
                        }
                    }
                });
            }
        }

       


        if(!Global.invinsibleActivated && !Global.gameOver){
            this.raycaster3.ray.origin.copy(this.carModel.position.clone());
            this.raycaster3.ray.direction.set(0, 0, -1).applyQuaternion(this.carModel.quaternion);
            const intersects4 = this.raycaster3.intersectObjects(otherCars, false);
            let AICarFound=false;
            if (intersects4.length > 0 && intersects4[0].distance < (this.vehicleKey=="Bike"?0.125:0.5)) {
                // this.speed *= (1 - Math.min(COLLISTION_SPEED_REDUCE_FACT * Global.delta, 1));
    
                const normal = intersects4[0].face.normal.clone();
                const carDirection = new THREE.Vector3();
                this.carModel.getWorldDirection(carDirection);
                const angle = carDirection.angleTo(normal)- Math.PI/4;
             
                this.speed *= 0.1;//1-Math.min(1, angle*WALL_COLLISTION_SPEED_REDUCE_FACT);
                this.baseSpeedCrossed= false;
                this.events.dispatchEvent({
                    type: "CAMERA_EVENTS",
                    message: {
                        "event_type": "shake_camera",
                        "data": {
                            "shake_fact": .1,
                            "intensity": 3,//intensity / 2,
                            "shake_time": 0.25
                        }
                    }
                });
                AICarFound= true;
                this.events.dispatchEvent({
                    type: "SOUND_EVENTS",
                    message: {
                        "event_type": "play_sound",
                        data: {
                            'sndKey': 'hit'
                        }
                    }
                });
            }
    
            
    
    
            if(!AICarFound){
                this.raycaster3.ray.origin.copy(this.carModel.position.clone());
                this.raycaster3.ray.direction.set(1, 0, -1).applyQuaternion(this.carModel.quaternion);
                const intersects5 = this.raycaster3.intersectObjects(otherCars, false);
                if (intersects5.length>0 && intersects5[0].distance<(this.vehicleKey=="Bike"?0.125:0.5)) {
                    var intersectionPoint = intersects5[0].point;
                    var distance = this.raycaster2.ray.origin.distanceTo(intersectionPoint);
                    var intensity = 1 / (distance + 1);
                    // this.carRotateZ -= Math.PI / 50 * Global.delta * (1 + intensity);
                    // this.speed *= (1 - Math.min(1 / 100 * Global.delta, 1));
        
                    const normal = intersects5[0].face.normal.clone();
                    const carDirection = new THREE.Vector3();
                    this.carModel.getWorldDirection(carDirection);
                    const angle = carDirection.angleTo(normal)- Math.PI/4;
                    this.speed *= 0.3;//1-Math.min(1, angle*WALL_COLLISTION_SPEED_REDUCE_FACT);
                    this.baseSpeedCrossed= false;
                        this.events.dispatchEvent({
                            type: "CAMERA_EVENTS",
                            message: {
                                "event_type": "shake_camera",
                                "data": {
                                    "shake_fact": .1,
                                    "intensity": 2,//intensity / 2,
                                    "shake_time": 0.25
                                }
                            }
                    });
                    this.events.dispatchEvent({
                        type: "SOUND_EVENTS",
                        message: {
                            "event_type": "play_sound",
                            data: {
                                'sndKey': 'hit'
                            }
                        }
                    });
                    AICarFound= true;
                }
            }
      
            if(!AICarFound){
                this.raycaster3.ray.origin.copy(this.carModel.position.clone());
                this.raycaster3.ray.direction.set(-1, 0, -1).applyQuaternion(this.carModel.quaternion);
                const intersects6 = this.raycaster3.intersectObjects(otherCars, false);
                 if (intersects6.length>0 && intersects6[0].distance<(this.vehicleKey=="Bike"?0.125:0.5)) {
                        var intersectionPoint = intersects6[0].point;
                        var distance = this.raycaster2.ray.origin.distanceTo(intersectionPoint);
                        var intensity = 1 / (distance + 1);
                        // this.carRotateZ += Math.PI / 50 * Global.delta * (1 + intensity);
                        // this.speed *= (1 - Math.min(1 / 100 * Global.delta, 1));
        
                        const normal = intersects6[0].face.normal.clone();
                        const carDirection = new THREE.Vector3();
                        this.carModel.getWorldDirection(carDirection);
                        const angle = carDirection.angleTo(normal)- Math.PI/4;
                        this.speed *= 0.3;//1-Math.min(1, angle*WALL_COLLISTION_SPEED_REDUCE_FACT);
                        this.baseSpeedCrossed= false;
                            this.events.dispatchEvent({
                                type: "CAMERA_EVENTS",
                                message: {
                                    "event_type": "shake_camera",
                                    "data": {
                                        "shake_fact": .1,
                                        "intensity": 2,//intensity / 2,
                                        "shake_time": 0.25
                                    }
                                }
                        });
                        this.events.dispatchEvent({
                            type: "SOUND_EVENTS",
                            message: {
                                "event_type": "play_sound",
                                data: {
                                    'sndKey': 'hit'
                                }
                            }
                        });
                    } 
            }
        }

        if(!Global.gameOver){
            this.raycaster3.ray.origin.copy(this.carModel.position.clone());
            this.raycaster3.ray.direction.set(0, 0, -1).applyQuaternion(this.carModel.quaternion);
            const intersects7 = this.raycaster3.intersectObjects([...Global.collectables], false);
            let canCollected=false;
            if (intersects7.length>0 && intersects7[0].distance<4*(isMobile?2:1) && intersects7[0].object.visible) {
                this.events.dispatchEvent({
                        type: "GAME_EVENTS",
                        message: {
                            "event_type": "collectables_aquired",
                            "data": {
                                "collect_type":intersects7[0].object.material.userData
                            }
                        }
                });
                intersects7[0].object.visible=false;
                canCollected= true;
            }
            const leftOffset = new THREE.Vector3(-1 / 2, 0, 0);
            const rightOffset = new THREE.Vector3(1 / 2, 0, 0);
            const leftOrigin = this.carModel.position.clone().add(leftOffset.applyQuaternion(this.carModel.quaternion));
            const rightOrigin = this.carModel.position.clone().add(rightOffset.applyQuaternion(this.carModel.quaternion));
            
            if(!canCollected){


                this.raycaster3.ray.origin.copy(leftOrigin);
                this.raycaster3.ray.direction.set(0, 0, -1).applyQuaternion(this.carModel.quaternion);
                const intersects8 = this.raycaster3.intersectObjects([...Global.collectables], false);
                if (intersects8.length>0 && intersects8[0].distance<4*(isMobile?2:1) && intersects8[0].object.visible) {
                    this.events.dispatchEvent({
                            type: "GAME_EVENTS",
                            message: {
                                "event_type": "collectables_aquired",
                                "data": {
                                    "collect_type":intersects8[0].object.material.userData
                                }
                            }
                    });
                    intersects8[0].object.visible=false;
                    canCollected= true;
                }
            }
            if(!canCollected){
                this.raycaster3.ray.origin.copy(rightOrigin);
                this.raycaster3.ray.direction.set(0, 0, -1).applyQuaternion(this.carModel.quaternion);
                const intersects9 = this.raycaster3.intersectObjects([...Global.collectables], false);
                if (intersects9.length>0 && intersects9[0].distance<4*(isMobile?2:1) && intersects9[0].object.visible) {
                    this.events.dispatchEvent({
                            type: "GAME_EVENTS",
                            message: {
                                "event_type": "collectables_aquired",
                                "data": {
                                    "collect_type":intersects9[0].object.material.userData
                                }
                            }
                    });
                    intersects9[0].object.visible=false;
                    canCollected= true;
                }
            }
        }

     
       
       

           
           
    }
  
    resetCarOnRoad(){
        this.missAlignedCnt=0;
        let closestPos = this.findNearestPointOnCurve(this.carModel.position);
        this.speed = 0;
        this.carRotateZ=0;
        this.baseSpeedCrossed = false;
    
    
        this.aiPos = Global.AIPath3.getPoint(closestPos + .001);
        this.aiPos2 = Global.AIPath3.getPoint(closestPos + .002);
    
        let nextPosX = THREE.MathUtils.lerp(this.carModel.position.x, this.aiPos.x, 1);
        let nextPosY = THREE.MathUtils.lerp(this.carModel.position.y, this.aiPos.y + 0.05, 1);
        let nextPosZ = THREE.MathUtils.lerp(this.carModel.position.z, this.aiPos.z, 1);
    
        let nextPos = new THREE.Vector3(nextPosX, nextPosY, nextPosZ);

        let direction = new THREE.Vector3().subVectors(this.aiPos2, this.carModel.position).normalize();
    
        // Calculate the angle around the Y-axis
        let angle = Math.atan2(direction.x, direction.z)+90;

        this.carModel.rotation.y = angle;
        this.carModel.position.copy(nextPos);

        this.resetInProgress=true;
        this.baseSpeedCrossed=false;
        this.speed=0;

        this.resetTwn && this.resetTwn.kill();

        const resetObj={
            'value':1
        }
        this.resetTwn= gsap.to(resetObj, {
            value:0.15,
            repeat: 5,
            yoyo: true,
            duration:0.25,
            onUpdate: function(){
                this.invinsibleMaterials.forEach((material)=>{
                    material.opacity=resetObj.value;
                })
            }.bind(this),
            onComplete: function(){
                this.speed=0;
                this.baseSpeedCrossed=false;
                this.resetInProgress=false;
            }.bind(this)
        })
    }
    reset(){
        this.showOrHiTailLight(0);
        this.gameStarted= false;
        this.lastForceY=0;
        this.carSpeedGyroReducer = 1;
        this.rotateWheel = true;
        this.initZ = -Math.PI * .97;
        this.carRotateZ = 0;
        // this.carRotateZ += Math.PI * data['forceX'] * (1 - Math.min(0.45/* 0.7 */,Math.pow(this.speed * CAR_SPEED_Z_REDUCER * this.carSpeedGyroReducer, CAR_SPEED_Z_EXP*1))) * ((this.speed).toFixed(2) != 0 ? 1 : 0) * Global.delta;//(Global.isGyro?0.6:1)

        // alert("DS")
        // this.carRotateZ = THREE.MathUtils.lerp(this.carRotateZ, 0, .0*Global.delta);
        
        this.speed = 0;
        this.firstChecked = false;
        this.stableY = 0;
        this.accDueToGravity = 0;
        this.lastDistance = 0;
        this.currDistance = 0;
        this.speedAqcuired = 0;
        
        this.rotateAngle = 0;
        this.brakeApplied = false;
        this.lightIntensity = {
            'value': 0
        }

        this.nowTotal = 0;
        this.lastTotal = 0;
        this.distanceCovered = 0;
        this.indicatorActive = false;
        if(this.carModel){
            this.carModel.rotation.set(0, 0, 0);
            this.carModel.position.set(...CAR_DEFAULT_POS);
            this.stableY = this.carModel.position.y;
        }
  
    }
    updateCar(data){
       this.addCarModel(data);
    }
    // Method to add the car model to the scene
    addCar(data) {
        this.shadowPlaneGe = new THREE.PlaneGeometry(40, 40);
        this.shadowPlaneMat = new THREE.ShadowMaterial({
            // color:'#ff0000',
            side: THREE.DoubleSide,
            depthWrite: false
        });
        this.shadowPlaneMat.transparent = true;
        this.shadowPlaneMat.opacity = 0.15;
        this.shadowPlane = new THREE.Mesh(this.shadowPlaneGe, this.shadowPlaneMat);
        this.scene.add(this.shadowPlane);
        this.shadowPlane.rotation.set(Math.PI / 2, 0, 0);
        this.shadowPlane.receiveShadow = true;

        // Cloning the car model from global assets

        

    

        this.carBox = new THREE.Mesh(new THREE.BoxGeometry(1.3, 1.5, 3), new THREE.MeshPhysicalMaterial({
            color: '#ffffff',
            transparent: true,
            opacity: 0.0,
            depthWrite: false
        }));
        this.scene.add(this.carBox)

        this.carBox2 = new THREE.Mesh(new THREE.BoxGeometry(1.5*15, 1, 1.5*15), new THREE.MeshPhysicalMaterial({
            color: '#ffffff',
            transparent: true,
            opacity: 1.0,
            depthWrite: false,
            depthTest:false
        }));
        this.scene.add(this.carBox2)


       

       
        // Global.userCar= this.carBox
        Global.cars.push(this.carBox);
        //    Global.cars.push(this.carModel);


        this.addCarModel(data);
        this.stableY = this.carModel.position.y;

        

    }
    addCarModel(data){
        this.vehicleKey=data['vehicleKey']
        this.maxSpeedIndicator=((this.vehicleKey=="Car")?500:(this.vehicleKey=="Bike")?450:400)*0.5;
        if(this.carModel){
            this.scene.remove(this.carModel);
        }

        this.carModel = Global.assets['glbs'][data['vehicleKey']]['asset'].scene;

        
        if(this.vehicleKey=="Bike"){
            this.animation = Global.assets['glbs'][data['vehicleKey']]['asset']['animations']
        this.turnMixer = new THREE.AnimationMixer(this.carModel);
        this.straightAnim = this.turnMixer.clipAction(this.animation[2]);
        this.leftAnim = this.turnMixer.clipAction(this.animation[0]); 
        this.rightAnim = this.turnMixer.clipAction(this.animation[1]);
        this.straightAnim.play();
        }

        // this.carModel.position.y+=10;
        this.scene.add(this.carModel);
        // Traversing the car model to configure wheel and material properties
        this.carModel.traverse(function (child) {
            // child.castShadow = true;
            if (child.isMesh && child.material.isMeshStandardMaterial) {
                                child.material.map && (child.material.map.encoding = THREE.sRGBEncoding, child.material.map.needsUpdate=true)
            
                   child.material.map && (child.material.map.colorSpace= THREE.SRGBColorSpace, child.material.map.needsUpdate=true);
                

                   if(child.material.name.toLowerCase().indexOf("shadow")==-1){
                    child.material.envMap=Global.envMap
                    child.material.envMapIntensity = 2.0;
                   }else{
                    child.material.envMapIntensity = 1.0;
               
                   }
                 
                   
                                // child.material.roughness=0.75
            }
            if (child.name.indexOf('light') != -1) {
                if (this.lightMaterial === null) {
                    this.lightMaterial = child.material.clone();
                    this.lightMaterial.color = new THREE.Color(0.25, 0, 0)
                    this.lightMaterial.emissive = new THREE.Color(1, 0, 0)
                    this.lightMaterial.emissiveIntensity = 0;
                }

                child.material = this.lightMaterial;
            }
            if(child.name.indexOf("car_shadow")!==-1){
                child.material.emissive="0xff0000"
                child.material.opacity=0.65
            }else if(child.material && this.invinsibleMaterials.indexOf(child.material)==-1){
                child.material.transparent=true;
                this.invinsibleMaterials.push(child.material)
            }
            if (child.name == 'wheel_back' || child.name== 'back_wheel') {
                child.rotation.order = "YZX";
                this.wheelBack = child;
            }
            if (child.name.indexOf('wheel_front1') != -1 || child.name.indexOf('front_wheel') != -1) {
                child.rotation.order = "YZX";
                this.frontWheel1 = child;
            }
            if (child.name.indexOf('wheel_front2') != -1) {
                if(this.vehicleKey !="Bike"){
                    child.rotation.order = "YZX";
                }
                this.frontWheel2 = child;
            }
            if (child.material) {
                // child.material.envMap = Global.assets['cubemap']['0']['asset'];
                // if (child.name.indexOf('paint') != -1) {
                //     child.material.envMapIntensity = 1.0;
                // }
            }
        }.bind(this));
        this.carModel.scale.set(CAR_SCALE, CAR_SCALE, CAR_SCALE);
        this.carModel.rotation.set(0, 0, 0);
        this.carModel.position.set(...CAR_DEFAULT_POS);

     
        this.carBox2.traverse((child) => {
            child.layers.set(2);
        });
        this.carBox.userData = {
            'carKey': this.carKey
        };
        // this.carPosTO= setTimeout(this.processPosition.bind(this), 200);
    }
    findNearestPointOnCurve(position) {
        if (!Global.AIPath3) return false;
        // Number of divisions to use for approximation
        const divisions = 1000;

        let nearestPoint = null;
        let pathTime = -1;
        let minDistance = Infinity;

        // Iterate through divisions to find the nearest point
        for (let i = 0; i <= divisions; i++) {
            const t = i / divisions;
            const pointOnCurve = Global.AIPath3.getPoint(t);
            pointOnCurve.x = position.x;
            const distance = position.distanceTo(pointOnCurve);

            if (distance < minDistance) {
                minDistance = distance;
                nearestPoint = pointOnCurve;
                pathTime = t;
            }
        }

        return pathTime;
    }
    dispose(){
        this.scene.remove(this.carModel);
        

        this.carModel && this.carModel.traverse(function (child) {
            if(child.geometry){
                child.geometry.dispose();
                child.geometry.dispose();
            }
        });
        this.carBox && this.carBox.traverse(function (child) {
            if(child.geometry){
                child.geometry.dispose();
                child.geometry.dispose();
            }
        });
        this.carBox2 && this.carBox2.traverse(function (child) {
            if(child.geometry){
                child.geometry.dispose();
                child.geometry.dispose();
            }
        });
        this.carModel && this.scene.remove(this.carModel);
        this.carBox && this.scene.remove(this.carBox);
        this.carBox2 && this.scene.remove(this.carBox2);

        this.events.removeEventListener("PLAYER_EVENTS", this.onEvents);
        this.events.removeEventListener("GAMESCENE_EVENTS", this.onEvents);
        this.events.removeEventListener("GAMECONTROL_EVENTS", this.onEvents);
        this.events.removeEventListener("GAME_EVENTS", this.onEvents);
    }
  
}
